var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget contact-properties" }, [
    _vm.showWidgetTitle
      ? _c("div", { staticClass: "widget-header" }, [
          _c("h3", { staticClass: "widget-title" }, [
            _vm._v(_vm._s(_vm.$t("message.contactInfo"))),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "widget-content" },
      [
        _vm._l(_vm.sortedContactProperties, function (element, index) {
          return _c(
            "div",
            { key: element._id, staticClass: "drag-row" },
            [
              _c("ContactDetailItem", {
                attrs: {
                  contact: _vm.contact,
                  label: _vm.getLabel(element),
                  value: _vm.getPropertyValue(element._id),
                  inputType: element.type,
                  options: element.options || [],
                },
                on: {
                  edit: function ($event) {
                    return _vm.updatePropertyValue(element._id, $event)
                  },
                  add: function ($event) {
                    return _vm.addPropertyValue(element._id, $event)
                  },
                  delete: function ($event) {
                    return _vm.deleteProperty(element._id)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "material-icons drag-handle" },
                            [_vm._v("drag_indicator")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "actions",
                      fn: function () {
                        return [
                          index > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-button move-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.moveUp(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("arrow_upward")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          index < _vm.sortedContactProperties.length - 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-button move-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.moveDown(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("arrow_downward")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.sortedContactProperties.length === 0
          ? _c("div", [_vm._v(_vm._s(_vm.$t("message.noPropertiesAdded")))])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }